import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Provider } from './provider';
import { InterestedDriver } from './interested-driver';

@inheritSerialization(AbstractModel)
export class ProviderSelectionDetail extends AbstractModel {
  @autoserializeAs(Provider)
  provider: Provider;

  @autoserializeAs(InterestedDriver)
  interestedDriver: InterestedDriver;

  @autoserialize
  providerIgnoringRide: boolean;
}
